import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../ComplianceRule.css';

class RestrictedSecurityOpRecordGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.restrictedSecurityOpRecordGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      rowSelection: "multiple",
    };
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    // const COLUMNS_KEY = 'fund-list-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      restrictedSecurityOperationRecordArray,
      className = 'grid-wrapper',
      loadRestrictedSecurityOperationRecordActionStatus,
    } = this.props;

    const isLoading = loadRestrictedSecurityOperationRecordActionStatus === ACTION_STATUS.LOGINING;
    if (loadRestrictedSecurityOperationRecordActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadRestrictedSecurityOperationRecordActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={restrictedSecurityOperationRecordArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            animateRows={true}
            immutableData={false}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default RestrictedSecurityOpRecordGrid;